






















import {Component, Prop, Vue} from 'vue-property-decorator';
import BulkUpdateRequest from '@/models/BulkUpdateRequest';
import { mapState } from 'vuex';
import moment from 'moment';

@Component({
  computed: mapState({
    partnerId: (state: any) => state.partner.id,
    isOnRequest: (state: any) => state.dashboard.isOnRequest,
  }),
})
export default class EditRoomStatus extends Vue {
  @Prop() public dropdown!: any;
  public partnerId!: string;

  get disableOpen() {
    return this.dropdown.type === 'I';
  }

  get disableStop() {
    return this.dropdown.type === 'U';
  }

  get showAutoStopSaleMessage(): boolean {
    return this.dropdown.stopSaleReason
      && ['rejected_partner', 'rejected_jarvis_booking'].indexOf(this.dropdown.stopSaleReason) > -1;
  }

  public onSoldOutClicked() {
    const { roomId, date } = this.dropdown;
    const tableComponent = (this.$parent.$parent.$refs[`roomTable-${roomId}`] as any);
    if (!tableComponent) {
      return;
    }
    const availabilityComponent = tableComponent[0].$refs[`availability-${date}`];
    if (!availabilityComponent) {
      return;
    }
    this.$dropdown.hide();
    availabilityComponent[0].availability = 1;
    availabilityComponent[0].showInput();
  }

  public async updateAvailability(status: string) {
    const error = (status === 'U' && this.disableStop) || (status === 'I' && this.disableOpen);
    if (error) {
      return false;
    } else {
      this.$store.commit('setDropdownRoomStatus', {
        ...this.dropdown,
        isLoading: true,
        show: false,
      });
      const payload = new BulkUpdateRequest(this.dropdown.roomId);
      payload.startDate = this.dropdown.date;
      payload.endDate = this.dropdown.date;
      payload.availabilityType = status;

      try {
        await this.$store.dispatch('bulkUpdate', payload);
        this.$store.dispatch('addToast', {
          type: 'success',
          message: 'messages.success.calendarUpdateApplied',
          timeout: 3,
        });
        this.$gtm.trackEvent({
          event: status === 'I' ? 'availabilityPageRoomStatusOpen' : 'availabilityPageRoomStatusClosed',
          partnerId: this.partnerId,
          status: {
            date: moment(this.dropdown.date, 'YYYY-MM-DD').format('DD-MM-YYYY'),
            day_of_the_week: moment(this.dropdown.date, 'YYYY-MM-DD').format('dddd'),
          },
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.$dropdown.hide();
      }
    }
  }

  private created() {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.$dropdown.hide();
      }
    });
  }

  private destroyed() {
    window.removeEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.$dropdown.hide();
      }
    });
  }
}
